module.exports = __webpack_public_path__ + "static/media/up-red.5ae55939.svg";